function Header(){
    return(
        <header class="test">
            <center><h3>My Web Application</h3></center>
        </header>
    );
}

export default Header;